import _ from 'lodash';
import {
  init,
  withScope,
  captureMessage,
  captureException,
  setUser,
} from '@sentry/browser';

const isProdEnv = () => {
  const env = __SENTRY_ENVIRONMENT__;
  if (env === 'development') {
    return false;
  }
  if (env === 'staging') {
    return false;
  }
  if (env === 'sales') {
    return false;
  }
  return true;
};

let exports;

if (__SENTRY__ === true) {
  init({
    dsn: __SENTRY_DSN__,
    name: __SENTRY_ENVIRONMENT__,
    ignoreUrls: [/127\.0\.0\.1/],
    ignoreErrors: ['BadRequestError', 'AuthenticationError'],
    release: __RELEASE__,
  });
  exports = {
    log: (message, optional = {}) => {
      const mergedOptional = _.merge({}, optional);
      console.info('Logging message to Sentry', message, mergedOptional); // eslint-disable-line
      withScope((scope) => {
        scope.setExtra('debug', false);
        captureMessage(message, mergedOptional);
      });
    },
    warn: (message, optional = {}) => {
      const mergedOptional = _.merge({}, optional);
      console.info('Logging message to Sentry', message, mergedOptional); // eslint-disable-line
      withScope((scope) => {
        scope.setExtra('debug', false);
        captureMessage(message, mergedOptional);
      });
    },
    error: (error, optional = {}) => {
      const mergedOptional = _.merge({}, optional);
      console.info('Logging error to Sentry', error, mergedOptional); // eslint-disable-line
      withScope((scope) => {
        scope.setExtra('debug', false);
        captureException(error, mergedOptional);
      });
    },
    env: () => __SENTRY_ENVIRONMENT__,
    setUser: id => setUser({ id }),
    isProdEnv,
  };
} else {
  exports = {
    log: (message, optional) => console.log('logging log', message, optional),  // eslint-disable-line
    warn: (message, optional) => console.log('logging warn', message, optional), // eslint-disable-line
    error: (message, optional) => console.log('logging error', message, optional), // eslint-disable-line
    env: () => __SENTRY_ENVIRONMENT__,
    setUser: () => {},
    isProdEnv,
  };
}

export default exports;
